import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ScopeOrganization } from '../types/scope-organization';
import { CONNECT_API } from '../shared/app-token';

/**
 * backend service handles all backend api request
 * which are related to users and organizations
 */
@Injectable({
    providedIn: 'root'
})
export class BackendService {
    /** reference on connect.fat api endpoint in environment */
    #apiUrl = inject(CONNECT_API);

    #httpClient = inject(HttpClient);

    /**
     * get organization details for given id
     * @param {string} OID - id of organization
     * @returns {object} - organization details
     */
    getScopeOrganisation(OID: string): Observable<ScopeOrganization> {
        return this.#httpClient
            .get<ScopeOrganization>(`${this.#apiUrl}/organizations/${OID}`)
            .pipe((organization) => organization);
    }
}
